import { Component, Input, OnInit } from '@angular/core';
import { AppState } from '@capacitor/app';
import { ModalController, ToastController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { ContactService } from 'src/app/services/contact.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.actions';

@Component({
  selector: 'app-send-points-success',
  templateUrl: './send-points-success.component.html',
  styleUrls: ['./send-points-success.component.scss'],
})
export class SendPointsSuccessComponent implements OnInit {

  @Input() details: any;
  @Input() payload: any;

  constructor(
    private modalController: ModalController,
    private store: Store<AppState>,
    private contactService: ContactService,
    private toastController: ToastController
  ) { }

  ngOnInit() {
    console.log({details: this.details});
  }

  dismiss(){
    this.modalController.dismiss();
  }

  formatDate(date){
    const newDate = new Date(date+" UTC").toString();
    return format(new Date(newDate), "MMMM dd, yyyy h:mma");
  }

  addContact(){
    this.store.dispatch(setLoadingSpinner({status: true}));
    const payload = {
      email: this.details?.receiver?.email,
      sortNumber: this.details?.receiver?.userId
    }
    this.contactService.createContact(payload).toPromise().then((res) => {
      if(res){
        this.store.dispatch(setLoadingSpinner({status: false}));
        console.log({res});
        this.presentToast('Contact saved!', 'middle', 'toastSuccess');
        this.modalController.dismiss();
      }
    })
    .catch( (err) => {
      if(err){
        this.store.dispatch(setLoadingSpinner({status: false}));
        if (err.status === 401 || err.status === 422 || err.status === 400 || err.status === 404 ||
          err.status === 500) {
          err.message = err.error.message;
        } else {
          err.message = `Error: Can't save contact, please try again.`;
        }
        this.presentToast(err.message, 'bottom', 'toastError');
      }
    });
  }

  async presentToast(msg, pos, style) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: pos,
      cssClass: style
    });
    toast.present();
  }

}
